// import DataTable from "react-data-table-component";
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import "react-datepicker/dist/react-datepicker.css";
// import Sidebar from "./Sidebar";
// import Navbar from "./Navbar";
// import tableColumns from "./TableColumns";
// import Papa from "papaparse";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { io } from "socket.io-client";
// import { useNavigate } from "react-router-dom";

// const Transactions = () => {
//   const navigate = useNavigate();
//   const [data, setData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalRows, setTotalRows] = useState(0);
//   const [dates, setDates] = useState({
//     startdate: "",
//     enddate: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [searchData, setSearchData] = useState("");
//   const [isDownloadEnabled, setIsDownloadEnabled] = useState(false);

//   useEffect(() => {
//     fetchData(currentPage, pageSize);
//     const socket = io(process.env.REACT_APP_BASE_URL, {
//       transports: ["websocket", "polling"],
//     });

//     socket.on("smsCreated", () => {
//       fetchData(currentPage, pageSize);
//     });

//     return () => {
//       socket.disconnect();
//     };
//   }, [currentPage, pageSize, dates.startdate, dates.enddate, searchData]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handlePerPageChange = (newPageSize) => {
//     setPageSize(newPageSize);
//     setCurrentPage(1);
//   };

//   const handleDates = (e) => {
//     const { name, value } = e.target;
//     setDates((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // const fetchData = async (page, limit) => {
//   //   const userDetails = JSON.parse(localStorage.getItem("user"));
//   //   if (!userDetails?.token) {
//   //     navigate("/logout");
//   //     return;
//   //   }

//   //   if ((dates.startdate && dates.enddate) || searchData != "") {
//   //     setLoading(true);
//   //   }

//   //   try {
//   //     // Validate dates if both are present
//   //     if (
//   //       dates.startdate &&
//   //       dates.enddate &&
//   //       new Date(dates.enddate) < new Date(dates.startdate)
//   //     ) {
//   //       toast.error("End date cannot be before start date");
//   //       return;
//   //     }

//   //     const params = {
//   //       page,
//   //       limit,
//   //       ...(searchData && { search: searchData }),
//   //       ...(dates.startdate && { startdate: dates.startdate }),
//   //       ...(dates.enddate && { enddate: dates.enddate }),
//   //     };

//   //     const endpoint =
//   //       (dates.startdate && dates.enddate) || searchData
//   //         ? "transaction-filter"
//   //         : "index";

//   //     const response = await axios.get(
//   //       `${process.env.REACT_APP_BASE_URL}${endpoint}`,
//   //       {
//   //         params,
//   //         headers: {
//   //           Authorization: `Bearer ${userDetails.token}`,
//   //         },
//   //       }
//   //     );

//   //     setData(response.data.result);
//   //     setTotalRows(response.data.totalRecords);
//   //   } catch (error) {
//   //     toast.error(error.response?.data?.message || "Error fetching data");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const fetchData = async (page, limit) => {
//     const userDetails = JSON.parse(localStorage.getItem("user"));
//     if (!userDetails?.token) {
//       navigate("/logout");
//       return;
//     }

//     if ((dates.startdate && dates.enddate) || searchData !== "") {
//       setLoading(true);
//     }

//     try {
//       if (
//         dates.startdate &&
//         dates.enddate &&
//         new Date(dates.enddate) < new Date(dates.startdate)
//       ) {
//         toast.error("End date cannot be before start date");
//         return;
//       }

//       const params = {
//         page,
//         limit,
//         ...(searchData && { search: searchData }),
//         ...(dates.startdate && { startdate: dates.startdate }),
//         ...(dates.enddate && { enddate: dates.enddate }),
//       };

//       const endpoint =
//         (dates.startdate && dates.enddate) || searchData
//           ? "transaction-filter"
//           : "index";

//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}${endpoint}`,
//         {
//           params,
//           headers: {
//             Authorization: `Bearer ${userDetails.token}`,
//           },
//         }
//       );

//       const resultData = response.data.result;

//       setData(resultData);
//       setTotalRows(response.data.totalRecords);

//       // Enable download only if filtered and result is not empty
//       const filtersApplied =
//         searchData !== "" || (dates.startdate && dates.enddate);
//       setIsDownloadEnabled(filtersApplied && resultData.length > 0);
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Error fetching data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const clearFilters = () => {
//     setDates({
//       startdate: "",
//       enddate: "",
//     });
//     setSearchData("");
//     setCurrentPage(1);
//     setIsDownloadEnabled(false);
//     setLoading(true);
//   };

//   const downloadCSV = async () => {
//     setLoading(true);
//     const userDetails = JSON.parse(localStorage.getItem("user"));
//     if (!userDetails?.token) {
//       setLoading(false);
//       navigate("/logout");
//       return;
//     }

//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}handle-csv`,
//         {
//           params: {
//             search: searchData,
//             ...(dates.startdate && { startdate: dates.startdate }),
//             ...(dates.enddate && { enddate: dates.enddate }),
//           },
//           headers: {
//             Authorization: `Bearer ${userDetails.token}`,
//           },
//         }
//       );

//       if (response.data.result?.length > 0) {
//         const csv = Papa.unparse(response.data.result);
//         const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(blob);
//         link.download = "Bank-Transaction.csv";
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       }
//     } catch (error) {
//       toast.error("Error downloading CSV");
//       console.error("Error fetching CSV data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const columns = tableColumns(currentPage, pageSize);

//   return (
//     <>
//       <ToastContainer />
//       <div id="wrapper">
//         <Sidebar />
//         <div id="content-wrapper" className="d-flex flex-column">
//           <div id="content">
//             <Navbar />
//             <div className="container-fluid">
//               <div className="card shadow mb-4">
//                 <div className="card-header py-3 d-flex justify-content-between">
//                   <h6 className="m-0 font-weight-bold text-primary">
//                     Bank Transactions Data
//                   </h6>
//                   <div className="d-flex align-items-center">
//                     {/* <div className="mx-2 d-flex flex-column">
//                       <label className="text-black">Search:</label>
//                       <div className="position-relative w-100">
//                         <input
//                           type="text"
//                           placeholder="Enter for search..."
//                           value={searchData}
//                           onChange={(e) => setSearchData(e.target.value)}
//                           className="w-100 pe-4"
//                         />
//                         {searchData && (
//                           <button
//                             type="button"
//                             onClick={() => setSearchData("")}
//                             // style={{
//                             //   width: "100%",
//                             //   paddingRight: "2.5rem", // Adjust padding for button space
//                             // }}
//                             className="position-absolute end-2 top-50 translate-middle-y border-0 bg-transparent text-secondary"
//                           >
//                             ✖
//                           </button>
//                         )}
//                       </div>
//                     </div> */}

//                     <div className="mx-2 d-flex flex-column">
//                       <label
//                         htmlFor="start-date"
//                         className="mx-2"
//                         style={{
//                           // marginTop: "3px",
//                           width: "auto",
//                           color: "black",
//                         }}
//                       >
//                         Search:
//                       </label>

//                       <div
//                         style={{
//                           position: "relative",
//                           display: "inline-block",
//                           width: "100%",
//                         }}
//                       >
//                         <input
//                           type="text"
//                           placeholder="Enter for search..."
//                           name="filter"
//                           value={searchData}
//                           onChange={(e) => setSearchData(e.target.value)}
//                           style={{
//                             width: "100%",
//                             paddingRight: "2.5rem", // Adjust padding for button space
//                           }}
//                         />
//                         {searchData && (
//                           <button
//                             type="button"
//                             onClick={() => setSearchData("")}
//                             style={{
//                               position: "absolute",
//                               right: "0.5rem",
//                               top: "50%",
//                               transform: "translateY(-50%)",
//                               border: "none",
//                               background: "transparent",
//                               cursor: "pointer",
//                               fontSize: "1.2rem",
//                               color: "#6c757d",
//                             }}
//                             aria-label="Clear"
//                           >
//                             ✖
//                           </button>
//                         )}
//                       </div>
//                     </div>

//                     <div className="d-flex flex-column">
//                       <label className="text-black">Start Date:</label>
//                       <input
//                         type="date"
//                         name="startdate"
//                         value={dates.startdate}
//                         onChange={handleDates}
//                         onKeyDown={(e) => e.preventDefault()}
//                       />
//                     </div>
//                     <div className="mx-2 d-flex flex-column">
//                       <label className="text-black">End Date:</label>
//                       <input
//                         type="date"
//                         name="enddate"
//                         value={dates.enddate}
//                         onChange={handleDates}
//                         onKeyDown={(e) => e.preventDefault()}
//                       />
//                     </div>

//                     <div className="mt-3 clear-all-btn">
//                       <button
//                         className="btn btn-primary me-2"
//                         onClick={clearFilters}
//                         disabled={
//                           !dates.startdate && !dates.enddate && !searchData
//                         }
//                         style={{ width: "110px" }}
//                       >
//                         Clear All
//                       </button>
//                       <button
//                         className="btn btn-primary"
//                         onClick={downloadCSV}
//                         style={{ width: "110px" }}
//                         disabled={!isDownloadEnabled}
//                       >
//                         Download
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="card-body">
//                   {loading && (
//                     <div className="text-center py-4">
//                       <div
//                         className="spinner-border text-primary"
//                         role="status"
//                       >
//                         {/* <span className="visually-hidden">Loading...</span> */}
//                       </div>
//                     </div>
//                   )}
//                   <div className="table-responsive">
//                     <DataTable
//                       columns={columns}
//                       data={data}
//                       pagination
//                       paginationServer
//                       paginationDefaultPage={currentPage}
//                       paginationTotalRows={totalRows}
//                       onChangeRowsPerPage={handlePerPageChange}
//                       onChangePage={handlePageChange}
//                       responsive={true}
//                       paginationPerPage={10} // Default rows per page
//                       paginationRowsPerPageOptions={[
//                         10, 25, 50, 100, 500, 1000,
//                       ]}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <footer className="sticky-footer bg-white">
//             <div className="container my-auto">
//               <div className="copyright text-center my-auto">
//                 <span>Copyright &copy; Blue Iris Software Trading LLC</span>
//               </div>
//             </div>
//           </footer>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Transactions;

// import DataTable from "react-data-table-component";
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import "react-datepicker/dist/react-datepicker.css";
// import Sidebar from "./Sidebar";
// import Navbar from "./Navbar";
// import tableColumns from "./TableColumns";
// import Papa from "papaparse";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { io } from "socket.io-client";
// import { useNavigate } from "react-router-dom";

// const Transactions = () => {
//   const navigate = useNavigate();
//   const [data, setData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalRows, setTotalRows] = useState(0);
//   const [dates, setDates] = useState({
//     startdate: "",
//     enddate: "",
//   });
//   const [appliedFilters, setAppliedFilters] = useState({
//     startdate: "",
//     enddate: "",
//     search: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [searchData, setSearchData] = useState("");
//   const [isDownloadEnabled, setIsDownloadEnabled] = useState(false);

//   useEffect(() => {
//     fetchData(currentPage, pageSize);

//     // this is for local "process.env.REACT_APP_BASE_URL" and this for stage process.env.REACT_APP_BASE_URL_APP"
//     const socket = io(process.env.REACT_APP_BASE_URL, {
//       transports: ["websocket", "polling"],
//     });

//     // const socket = io(process.env.REACT_APP_BASE_URL_APP); //this use for prod env

//     socket.on("smsCreated", () => {
//       fetchData(currentPage, pageSize);
//     });

//     return () => {
//       socket.disconnect();
//     };
//   }, [currentPage, pageSize, appliedFilters]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handlePerPageChange = (newPageSize) => {
//     setPageSize(newPageSize);
//     setCurrentPage(1);
//   };

//   const handleDates = (e) => {
//     const { name, value } = e.target;
//     setDates((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const applyFilters = () => {
//     if (
//       dates.startdate &&
//       dates.enddate &&
//       new Date(dates.enddate) < new Date(dates.startdate)
//     ) {
//       toast.error("End date cannot be before start date");
//       return;
//     }

//     setAppliedFilters({
//       startdate: dates.startdate,
//       enddate: dates.enddate,
//       search: searchData,
//     });
//     setCurrentPage(1); // Reset to first page when filters change
//   };

//   const fetchData = async (page, limit) => {
//     const userDetails = JSON.parse(localStorage.getItem("user"));
//     if (!userDetails?.token) {
//       navigate("/logout");
//       return;
//     }

//     if (
//       (appliedFilters.startdate && appliedFilters.enddate) ||
//       appliedFilters.search !== ""
//     ) {
//       setLoading(true);
//     }

//     try {
//       const params = {
//         page,
//         limit,
//         ...(appliedFilters.search && { search: appliedFilters.search }),
//         ...(appliedFilters.startdate && {
//           startdate: appliedFilters.startdate,
//         }),
//         ...(appliedFilters.enddate && { enddate: appliedFilters.enddate }),
//       };

//       const endpoint =
//         (appliedFilters.startdate && appliedFilters.enddate) ||
//         appliedFilters.search
//           ? "transaction-filter"
//           : "index";

//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}${endpoint}`,
//         {
//           params,
//           headers: {
//             Authorization: `Bearer ${userDetails.token}`,
//           },
//         }
//       );

//       const resultData = response.data.result;

//       setData(resultData);
//       setTotalRows(response.data.totalRecords);

//       // Enable download only if filtered and result is not empty
//       const filtersApplied =
//         appliedFilters.search !== "" ||
//         (appliedFilters.startdate && appliedFilters.enddate);
//       setIsDownloadEnabled(filtersApplied && resultData.length > 0);
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Error fetching data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const clearFilters = () => {
//     setDates({
//       startdate: "",
//       enddate: "",
//     });
//     setSearchData("");
//     setAppliedFilters({
//       startdate: "",
//       enddate: "",
//       search: "",
//     });
//     setCurrentPage(1);
//     setIsDownloadEnabled(false);
//     setLoading(true);
//   };

//   const downloadCSV = async () => {
//     setLoading(true);
//     const userDetails = JSON.parse(localStorage.getItem("user"));
//     if (!userDetails?.token) {
//       setLoading(false);
//       navigate("/logout");
//       return;
//     }

//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}handle-csv`,
//         {
//           params: {
//             search: appliedFilters.search,
//             ...(appliedFilters.startdate && {
//               startdate: appliedFilters.startdate,
//             }),
//             ...(appliedFilters.enddate && { enddate: appliedFilters.enddate }),
//           },
//           headers: {
//             Authorization: `Bearer ${userDetails.token}`,
//           },
//         }
//       );

//       if (response.data.result?.length > 0) {
//         const csv = Papa.unparse(response.data.result);
//         const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(blob);
//         link.download = "Bank-Transaction.csv";
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       }
//     } catch (error) {
//       toast.error("Error downloading CSV");
//       console.error("Error fetching CSV data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const columns = tableColumns(currentPage, pageSize);

//   return (
//     <>
//       <ToastContainer />
//       <div id="wrapper">
//         <Sidebar />
//         <div id="content-wrapper" className="d-flex flex-column">
//           <div id="content">
//             <Navbar />
//             <div className="container-fluid">
//               <div className="card shadow mb-4">
//                 <div className="card-header py-3 d-flex justify-content-between">
//                   <h6 className="m-0 font-weight-bold text-primary">
//                     Bank Transactions Data
//                   </h6>
//                   <div className="d-flex align-items-center">
//                     <div className="mx-2 d-flex flex-column">
//                       <label
//                         htmlFor="start-date"
//                         className="mx-2"
//                         style={{
//                           width: "auto",
//                           color: "black",
//                         }}
//                       >
//                         Search:
//                       </label>

//                       <div
//                         style={{
//                           position: "relative",
//                           display: "inline-block",
//                           width: "100%",
//                         }}
//                       >
//                         <input
//                           type="text"
//                           placeholder="Enter for search..."
//                           name="filter"
//                           value={searchData}
//                           onChange={(e) => setSearchData(e.target.value)}
//                           style={{
//                             width: "100%",
//                             paddingRight: "2.5rem",
//                           }}
//                         />
//                         {searchData && (
//                           <button
//                             type="button"
//                             onClick={() => setSearchData("")}
//                             style={{
//                               position: "absolute",
//                               right: "0.5rem",
//                               top: "50%",
//                               transform: "translateY(-50%)",
//                               border: "none",
//                               background: "transparent",
//                               cursor: "pointer",
//                               fontSize: "1.2rem",
//                               color: "#6c757d",
//                             }}
//                             aria-label="Clear"
//                           >
//                             ✖
//                           </button>
//                         )}
//                       </div>
//                     </div>

//                     <div className="d-flex flex-column">
//                       <label className="text-black">Start Date:</label>
//                       <input
//                         type="date"
//                         name="startdate"
//                         value={dates.startdate}
//                         onChange={handleDates}
//                         onKeyDown={(e) => e.preventDefault()}
//                       />
//                     </div>
//                     <div className="mx-2 d-flex flex-column">
//                       <label className="text-black">End Date:</label>
//                       <input
//                         type="date"
//                         name="enddate"
//                         value={dates.enddate}
//                         onChange={handleDates}
//                         onKeyDown={(e) => e.preventDefault()}
//                       />
//                     </div>

//                     <div className="mt-3 clear-all-btn">
//                       <button
//                         className="btn btn-primary me-2"
//                         onClick={applyFilters}
//                         style={{ width: "110px" }}
//                       >
//                         Apply Filter
//                       </button>
//                       <button
//                         className="btn btn-primary me-2"
//                         onClick={clearFilters}
//                         disabled={
//                           !appliedFilters.startdate &&
//                           !appliedFilters.enddate &&
//                           !appliedFilters.search
//                         }
//                         style={{ width: "110px" }}
//                       >
//                         Clear All
//                       </button>
//                       <button
//                         className="btn btn-primary"
//                         onClick={downloadCSV}
//                         style={{ width: "110px" }}
//                         disabled={!isDownloadEnabled}
//                       >
//                         Download
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="card-body">
//                   {loading && (
//                     <div className="text-center py-4">
//                       <div
//                         className="spinner-border text-primary"
//                         role="status"
//                       ></div>
//                     </div>
//                   )}
//                   <div className="table-responsive">
//                     <DataTable
//                       columns={columns}
//                       data={data}
//                       pagination
//                       paginationServer
//                       paginationDefaultPage={currentPage}
//                       paginationTotalRows={totalRows}
//                       onChangeRowsPerPage={handlePerPageChange}
//                       onChangePage={handlePageChange}
//                       responsive={true}
//                       paginationPerPage={10}
//                       paginationRowsPerPageOptions={[
//                         10, 25, 50, 100, 500, 1000,
//                       ]}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <footer className="sticky-footer bg-white">
//             <div className="container my-auto">
//               <div className="copyright text-center my-auto">
//                 <span>Copyright &copy; Blue Iris Software Trading LLC</span>
//               </div>
//             </div>
//           </footer>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Transactions;

// ---------------------------
import DataTable from "react-data-table-component";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import tableColumns from "./TableColumns";
import Papa from "papaparse";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";

const Transactions = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [dates, setDates] = useState({ startdate: "", enddate: "" });
  const [appliedFilters, setAppliedFilters] = useState({
    startdate: "",
    enddate: "",
    search: "",
  });
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [isDownloadEnabled, setIsDownloadEnabled] = useState(false);

  // Flag to identify socket-triggered fetch
  const isRefetchDueToSocket = useRef(false);

  useEffect(() => {
    fetchData(currentPage, pageSize);

    // const socket = io(process.env.REACT_APP_BASE_URL, {
    //   transports: ["websocket", "polling"],
    // });

    const socket = io(process.env.REACT_APP_BASE_URL_APP); //this use for prod env

    socket.on("smsCreated", () => {
      isRefetchDueToSocket.current = true;
      fetchData(currentPage, pageSize);
    });

    return () => {
      socket.disconnect();
    };
  }, [currentPage, pageSize, appliedFilters]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setCurrentPage(1);
  };

  const handleDates = (e) => {
    const { name, value } = e.target;
    setDates((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    if (
      dates.startdate &&
      dates.enddate &&
      new Date(dates.enddate) < new Date(dates.startdate)
    ) {
      toast.error("End date cannot be before start date");
      return;
    }

    setAppliedFilters({
      startdate: dates.startdate,
      enddate: dates.enddate,
      search: searchData,
    });
    setCurrentPage(1);
  };

  const fetchData = async (page, limit) => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (!userDetails?.token) {
      navigate("/logout");
      return;
    }

    const filtersApplied =
      (appliedFilters.startdate && appliedFilters.enddate) ||
      appliedFilters.search !== "";

    // Show loader only if NOT socket-triggered fetch
    if (!isRefetchDueToSocket.current && filtersApplied) {
      setLoading(true);
    }

    try {
      const params = {
        page,
        limit,
        ...(appliedFilters.search && { search: appliedFilters.search }),
        ...(appliedFilters.startdate && {
          startdate: appliedFilters.startdate,
        }),
        ...(appliedFilters.enddate && { enddate: appliedFilters.enddate }),
      };

      const endpoint = filtersApplied ? "transaction-filter" : "index";

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}${endpoint}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        }
      );

      const resultData = response.data.result;

      setData(resultData);
      setTotalRows(response.data.totalRecords);

      // Enable download only if filtered and result is not empty
      setIsDownloadEnabled(filtersApplied && resultData.length > 0);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error fetching data");
    } finally {
      // Reset loader unless it was a socket-triggered fetch
      if (!isRefetchDueToSocket.current) {
        setLoading(false);
      }
      isRefetchDueToSocket.current = false; // Reset after fetch
    }
  };

  const clearFilters = () => {
    setDates({ startdate: "", enddate: "" });
    setSearchData("");
    setAppliedFilters({ startdate: "", enddate: "", search: "" });
    setCurrentPage(1);
    setIsDownloadEnabled(false);
    setLoading(true);
  };

  const downloadCSV = async () => {
    setLoading(true);
    const userDetails = JSON.parse(localStorage.getItem("user"));
    if (!userDetails?.token) {
      setLoading(false);
      navigate("/logout");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}handle-csv`,
        {
          params: {
            search: appliedFilters.search,
            ...(appliedFilters.startdate && {
              startdate: appliedFilters.startdate,
            }),
            ...(appliedFilters.enddate && { enddate: appliedFilters.enddate }),
          },
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        }
      );

      if (response.data.result?.length > 0) {
        const csv = Papa.unparse(response.data.result);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Bank-Transaction.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      toast.error("Error downloading CSV");
      console.error("Error fetching CSV data:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = tableColumns(currentPage, pageSize);

  return (
    <>
      <ToastContainer />
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex justify-content-between">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Bank Transactions Data
                  </h6>
                  <div className="d-flex align-items-center">
                    <div className="mx-2 d-flex flex-column">
                      <label htmlFor="start-date" className="mx-2 text-black">
                        Search:
                      </label>
                      <div style={{ position: "relative", width: "100%" }}>
                        <input
                          type="text"
                          placeholder="Enter for search..."
                          name="filter"
                          value={searchData}
                          onChange={(e) => setSearchData(e.target.value)}
                          style={{ width: "100%", paddingRight: "2.5rem" }}
                        />
                        {searchData && (
                          <button
                            type="button"
                            onClick={() => setSearchData("")}
                            style={{
                              position: "absolute",
                              right: "0.5rem",
                              top: "50%",
                              transform: "translateY(-50%)",
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              fontSize: "1.2rem",
                              color: "#6c757d",
                            }}
                            aria-label="Clear"
                          >
                            ✖
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="d-flex flex-column">
                      <label className="text-black">Start Date:</label>
                      <input
                        type="date"
                        name="startdate"
                        value={dates.startdate}
                        onChange={handleDates}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="mx-2 d-flex flex-column">
                      <label className="text-black">End Date:</label>
                      <input
                        type="date"
                        name="enddate"
                        value={dates.enddate}
                        onChange={handleDates}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>

                    <div className="mt-3 clear-all-btn">
                      <button
                        className="btn btn-primary me-2"
                        onClick={applyFilters}
                        style={{ width: "110px" }}
                      >
                        Apply Filter
                      </button>
                      <button
                        className="btn btn-primary me-2"
                        onClick={clearFilters}
                        disabled={
                          !appliedFilters.startdate &&
                          !appliedFilters.enddate &&
                          !appliedFilters.search
                        }
                        style={{ width: "110px" }}
                      >
                        Clear All
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={downloadCSV}
                        style={{ width: "110px" }}
                        disabled={!isDownloadEnabled}
                      >
                        Download
                      </button>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  {loading && (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      ></div>
                    </div>
                  )}

                  <div className="table-responsive">
                    <DataTable
                      columns={columns}
                      data={data}
                      pagination
                      paginationServer
                      paginationDefaultPage={currentPage}
                      paginationTotalRows={totalRows}
                      onChangeRowsPerPage={handlePerPageChange}
                      onChangePage={handlePageChange}
                      responsive={true}
                      paginationPerPage={10}
                      paginationRowsPerPageOptions={[
                        10, 25, 50, 100, 500, 1000,
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <footer className="sticky-footer bg-white">
            <div className="container my-auto">
              <div className="copyright text-center my-auto">
                <span>Copyright &copy; Blue Iris Software Trading LLC</span>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Transactions;
